import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table, Button} from  'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalDetails from './modalDetails';
import moment from 'moment';
import Help from '../../generics/help';
const Config = require('../../../config');

class WarehouseSupplies extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);

		this.state = {
			products:[],
			totals: [],
			filter:"",
		}
	}

	componentDidMount(){
		

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_reagents/stock/'+sessionStorage.getItem('health_facilities_id'),{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var products = [];
				var totals = [];

				response.map((res)=>{
					var count = 0
					var min = res.product.min;
					var max = res.product.max;
					res.stock.map((s)=>{

						var aux = {
							name: res.product.name,
							code: res.product.code,
							barcode: res.product.barcode,
							presentation: res.product.presentation,
							lote: s.lot_number,
							amount: s.total,
							caducidad:moment(s.expirate_date).format('DD/MM/YYYY'),
							color:this.dateCompare(
										moment(s.expirate_date).format('DD/MM/YYYY'), 
										moment(res.today).format('DD/MM/YYYY')
									) ? '' : '#ec6874'
						}

						count += s.total;

						products.push(aux);
					
						
					})

					totals.push({
						product: res.product.name,
						amount: count,
						color: count < min || count > max ? 'red' : ''
					});

				})

				this.setState({products:products, totals: totals});
			}
		});
	}

	dateCompare(cad, today){
		var date_ok = true;

		if(cad < today){
			date_ok = false
		}

		return date_ok;
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.name !== null &&
				row.code !== null &&
				row.barcode !== null &&
				row.presentation !== null
			){
				if(
					row.name.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.code.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.barcode.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.presentation.indexOf(this.state.filter.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	viewInformation(id, name){
		this.modal_details.handleShow(id, name);
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Almacén
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_storage"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

				</div>

				<div className="col-xs-12">
					<fieldset>
						<legend>Insumos</legend>
						<Table responsive hover>
							<thead>
								<tr>
									<th>Nombre</th>
									<th>Codigo</th>
									{/*<th>Codigo de Barras</th>*/}
									<th>Presentación</th>
									<th>Lote</th>
									<th>Cantidad</th>
									<th>Caducidad</th>
								</tr>
							</thead>
							<tbody>
								{this.state.products.map((p, i)=>{
									return  this.filter(p) ?
										<tr key={i} className={p.color !== "" ? 'danger' : ''}>
											<td>{p.name}</td>
											<td>{p.code}</td>
											{/*<td>{p.barcode}</td>*/}
											<td>{p.presentation}</td>
											<td>{p.lote}</td>
											<td>{p.amount}</td>
											<td>{p.caducidad}</td>
										</tr>
									: null
								})}
							</tbody>
						</Table>
					</fieldset>
				</div>

				<div className="col-xs-12 col-sm-6">
					<fieldset>
						<legend>Totales</legend>
						<Table responsive hover>
							<thead>
								<tr>
									<th>Nombre</th>
									<th>Total</th>
								</tr>
							</thead>
							<tbody>
								{this.state.totals.map((p, i)=>(
									<tr key={i} className={p.color !== "" ? 'danger' : ''}>
										<td>{p.product}</td>
										<td>{p.amount}</td>
									</tr>
								))}
							</tbody>
						</Table>
					</fieldset>
				</div>



				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(WarehouseSupplies);